import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postGetProductionByIds(params) {
  const res = await selfAxios.post(`/designapi/design/production/getProductionByIds`, params);
  return res.data;
}
export { postGetProductionByIds };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/production/getProductionByIds/post.js